import { getRoutePoints } from "./calc";

export const DEFAULT_DOT_COLOR = "black";
export const DEFAULT_DOT_SIZE = 3;
export const DEFAULT_CIRCLE_RADIUS = 3
export const DEFAULT_CIRCLE_COLOR = "orange"

export const drawLink = (start, end, context) => {
  context.beginPath();
  context.moveTo(start.x, start.y);
  context.lineTo(end.x, end.y);
  context.lineWidth = 1;
  context.strokeStyle = "#0000FF";
  context.stroke();
};

export const paintDot = (
  context,
  dot,
  color = DEFAULT_DOT_COLOR,
  size = DEFAULT_DOT_SIZE
) => {
  context.fillStyle = color;
  if (size) context.fillRect(dot.x, dot.y, size, size);
  else context.fillRect(dot.x, dot.y, dot.w, dot.h);
};

export const paintCircle = (
  context,
  dot,
  radius = DEFAULT_CIRCLE_RADIUS,
  color = DEFAULT_CIRCLE_COLOR
  ) => {
  context.beginPath();
  context.arc(dot.x, dot.y, radius, 0, 2 * Math.PI, false);
  context.fillStyle = color;
  context.fill();
}

export const drawRoute = (nodesArray, mContext) => {
  //setup();
  mContext.fillStyle = "red";
  var mPoints = getRoutePoints(nodesArray);
  context = mContext;
  points = mPoints;
  t = 1;
  if(nodesArray.length > 0)
    animate()
  else alert("Ruta no encontrada")
};

var context;
var points;
var t = 1;
function animate() {
  if (t < points.length - 1) {
    requestAnimationFrame(animate);
  }
  context.lineWidth = 3;
  context.strokeStyle = "#F00";
  context.beginPath();
  context.moveTo(points[t - 1].x, points[t - 1].y);
  context.lineTo(points[t].x, points[t].y);
  context.stroke();
  t++;
}
/*
function setup() {
  var lastTime = 0;
  var vendors = ["ms", "moz", "webkit", "o"];
  for (var x = 0; x < vendors.length && !window.requestAnimationFrame; ++x) {
    window.requestAnimationFrame = window[vendors[x] + "RequestAnimationFrame"];
    window.cancelAnimationFrame =
      window[vendors[x] + "CancelAnimationFrame"] ||
      window[vendors[x] + "CancelRequestAnimationFrame"];
  }

  if (!window.requestAnimationFrame)
    window.requestAnimationFrame = function(callback, element) {
      var currTime = new Date().getTime();
      var timeToCall = Math.max(0, 16 - (currTime - lastTime));
      var id = window.setTimeout(function() {
        callback(currTime + timeToCall);
      }, timeToCall);
      lastTime = currTime + timeToCall;
      return id;
    };

  if (!window.cancelAnimationFrame)
    window.cancelAnimationFrame = function(id) {
      clearTimeout(id);
    };
}*/



// WEBPACK FOOTER //
// src/utils/canvasPainter.js